import { RefObject, useLayoutEffect } from 'react'

const usePinScrollToBottom = (
  scrollContainer: RefObject<HTMLElement>,
  itemsCount: number | undefined
) => {
  useLayoutEffect(() => {
    if (!scrollContainer.current) return

    const { scrollHeight, clientHeight, scrollTop } = scrollContainer.current
    const scrollBottom = scrollHeight - clientHeight - scrollTop

    const commentElements = scrollContainer.current.children

    // last one is the padding from the ViewportList so it needs to be -2
    const lastCommentElement = commentElements.item(commentElements.length - 2)
    const lastCommentHeight = lastCommentElement?.clientHeight ?? 0

    const { matches: prefersReducedMotion } = matchMedia(
      '(prefers-reduced-motion: reduce)'
    )

    // giving some leeway for clamping the scroll to the bottom of the list
    if (scrollBottom < lastCommentHeight + 200) {
      setTimeout(() => {
        scrollContainer.current?.scrollTo({
          behavior: prefersReducedMotion ? 'instant' : 'smooth',
          top: scrollHeight + 1000,
        })
      }, 100)
    }
  }, [itemsCount, scrollContainer])
}

export { usePinScrollToBottom }
